import { Form, Modal, Input, Button, Select, Space, InputNumber, Row, Col, Checkbox } from "antd";
import React, { useEffect, useState } from "react";
import { getDirectusClient } from "../../../lib/directus";
import { useForm } from "antd/es/form/Form";
import { createUser, readItems, readRoles } from "@directus/sdk";
import { useSelector } from "react-redux";
import moment from "moment";

const { Option } = Select;

function Createseller(props) {
  const [roles, setRoles] = useState([]);
  const [bodegas, setBodegas] = useState([]);
  const [prestamo, setPrestamo] = useState(false);
  const [showCreditFields, setShowCreditFields] = useState(false);
  const userdata = useSelector(state=>state.userdata)
  
  const [form] = useForm();

  const Roles = async () => {
    const directus = await getDirectusClient();

    directus
      .request(
        readRoles({
          filter: {
            name: {
            _eq: "clientes"
          }
        }
      }))
      .then((res) => {
        console.log(res);
        setRoles(res);
      })
      .catch((err) => console.log(err));
  };

  const Bodegas = async () => {
    const directus = await getDirectusClient();
    console.log("userdata", userdata.role.name);

    directus
      .request(
        readItems("bodegas", {
          filter: {
            ...(userdata.role.name === "coordinador_ruta" || userdata.role.name=="supervisor_ruta" ? { id: { _eq: userdata.bodega.id } } : {}),
        }
      }))
      .then((res) => {
        console.log(res);
        setBodegas(res);
      })
      .catch((err) => console.log(err));
  };

  const onFinish = async (values) => {
    const directus = await getDirectusClient();

    directus
      .request(
     createUser(values))
      .then((res) => {
        console.log(res);
        if (res.id) {
          props.closeCreate();
          form.resetFields();
          props.getSellers();
        }
      })
      .catch((err) => console.log(err));
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleCreditChange = (checked) => {
    setShowCreditFields(checked);
    form.setFieldsValue({
      credito: checked,
      // Clear credit related fields if unchecking
      ...((!checked) && {
        dias_max_credito: undefined,
        tope_credito: undefined
      })
    });
  };

  useEffect(() => {
    form.setFieldValue("email", new Date().getTime() + "client@emesmart.com");  
    form.setFieldValue("password", new Date().getTime() + "client");
    form.setFieldValue("latitude", 0)
    form.setFieldValue("longitude", 0)
    Roles();
    Bodegas();
  }, []);
  return (
    <Modal
      open={props.opencreate}
      onCancel={props.closeCreate}
      title="Crear Cliente"
      footer={[
        <Button key="back" onClick={props.closeCreate}>
          cancelar
        </Button>,
      ]}
           width={1000}
    >
      <div style={{ margin: 20 }}>
        <Form
          form={form}
          name="basic"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          style={{ maxWidth: '100%' }}
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Nombre"
                name="first_name"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Tipo persona"
                name="tipo_cliente"
                rules={[{ required: true, message: 'Por favor seleccione el tipo de cliente' }]}
              >
                <Select>
                  <Option value="natural">Natural</Option>
                  <Option value="juridica">Jurídica</Option>
                </Select>
              </Form.Item>

              <Form.Item
                label="Documento"
                name="documento"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Celular"
                name="celular"
                rules={[
                  { required: true },
                  { max: 8, message: 'El celular debe tener máximo 8 dígitos' },
                  { pattern: /^[0-9]*$/, message: 'Solo se permiten números' }
                ]}
              >
                <Input maxLength={8} />
              </Form.Item>
              <Form.Item
                label="Telefono"
                name="telefono"
                rules={[
                  { required: true },
                  { pattern: /^[0-9]*$/, message: 'Solo se permiten números' }
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Representante legal"
                name="representante_legal"
                rules={[{ required: true, message: 'Por favor ingrese el representante legal' }]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                name="role"
                label="Rol"
                rules={[{ required: true }]}
              >
                <Select
                  placeholder="Seleccione un rol"
                  allowClear
                  onChange={(select) => {
                    if (select == "7fccd349-4875-4618-b770-344c5cc2e0d8") {
                      setPrestamo(true);
                    } else {
                      setPrestamo(false);
                    }
                  }}
                >
                  {roles?.map((rol) => (
                    <Option key={rol.id} value={rol.id}>
                      {rol.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="Latitude"
                name="latitude"
                rules={[{ required: false }]}
              >
                <Input />
              </Form.Item>

              {prestamo && (
                <Form.Item
                  label="Tope de prestamo"
                  name="tope_de_prestamo"
                  rules={[{ required: false }]}
                >
                  <InputNumber style={{ width: '100%' }} />
                </Form.Item>
              )}
            </Col>

            <Col span={12}>
              <Form.Item
                label="Apellidos"
                name="last_name"
         
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="Correo"
                name="email"
                rules={[{ required: true, type: "email" }]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                name="bodega"
                label="Bodega"
                rules={[{ required: true }]}
              >
                <Select placeholder="Seleccione una Bodega" allowClear>
                  {bodegas?.map((bodega) => (
                    <Option key={bodega.id} value={bodega.id}>
                      {bodega.nombre}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="Longitude"
                name="longitude"
                rules={[{ required: false }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="¿Credito?"
                name="credito"
                valuePropName="checked"
                initialValue={false}
              >
                <Checkbox onChange={(e) => handleCreditChange(e.target.checked)} />
              </Form.Item>
              {showCreditFields && (
                <>
                  <Form.Item
                    label="Tope de credito"
                    name="tope_credito"
                    rules={[{ required: true, message: 'Por favor ingrese el tope de crédito' }]}
                  >
                    <InputNumber style={{ width: '100%' }} />
                  </Form.Item>

                  <Form.Item
                    label="Dias de credito"
                    name="dias_max_credito"
                    rules={[{ required: true, message: 'Por favor ingrese los días de crédito' }]}
                  >
                    <InputNumber style={{ width: '100%' }} />
                  </Form.Item>
                </>
              )}

              <Form.Item
                label="Contraseña"
                name="password"
                rules={[{ required: false }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={24} style={{ textAlign: 'right' }}>
              <Form.Item>
                <Button type="primary" htmlType="submit">
                  Guardar Cliente
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </Modal>
  );
}

export default Createseller;
